import styled, { css } from 'styled-components';

export const ListWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.sz.s4};
    align-items: center;
  `,
);
